var _ellipse, _ellipse2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.16675,
    rx: 2.5,
    ry: 2.5,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.16675,
    rx: 2.5,
    ry: 2.5,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7148 13.8808L11.179 17.4167C10.5282 18.0667 9.47389 18.0667 8.82315 17.4167L5.28648 13.8808C2.68309 11.2773 2.68316 7.05627 5.28665 4.45283C7.89013 1.84938 12.1112 1.84938 14.7147 4.45283C17.3181 7.05627 17.3182 11.2773 14.7148 13.8808V13.8808Z",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7148 13.8808L11.179 17.4167C10.5282 18.0667 9.47389 18.0667 8.82315 17.4167L5.28648 13.8808C2.68309 11.2773 2.68316 7.05627 5.28665 4.45283C7.89013 1.84938 12.1112 1.84938 14.7147 4.45283C17.3181 7.05627 17.3182 11.2773 14.7148 13.8808V13.8808Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/positionIcon.a50e59911228577da5326d50c58dba99.svg";
export { ForwardRef as ReactComponent };